import { render, staticRenderFns } from "./ForgotPasswordMobilPlus.vue?vue&type=template&id=58b01e08&scoped=true"
import script from "./ForgotPasswordMobilPlus.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordMobilPlus.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=58b01e08&prod&scoped=true&lang=css&external"
import style1 from "./ForgotPasswordMobilPlus.vue?vue&type=style&index=1&id=58b01e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b01e08",
  null
  
)

export default component.exports